@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.loan_application.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mifos_mobile.feature.loan_application.generated.resources/"

internal val Res.string.attach: StringResource by lazy {
      StringResource("string:attach", "attach", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 22),
      ))
    }

internal val Res.string.capture: StringResource by lazy {
      StringResource("string:capture", "capture", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33, 27),
      ))
    }

internal val Res.string.feature_apply_loan_action_cancel: StringResource by lazy {
      StringResource("string:feature_apply_loan_action_cancel", "feature_apply_loan_action_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61, 48),
      ))
    }

internal val Res.string.feature_apply_loan_action_continue: StringResource by lazy {
      StringResource("string:feature_apply_loan_action_continue", "feature_apply_loan_action_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110, 54),
      ))
    }

internal val Res.string.feature_apply_loan_action_discard: StringResource by lazy {
      StringResource("string:feature_apply_loan_action_discard", "feature_apply_loan_action_discard", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165, 53),
      ))
    }

internal val Res.string.feature_apply_loan_action_retry: StringResource by lazy {
      StringResource("string:feature_apply_loan_action_retry", "feature_apply_loan_action_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219, 47),
      ))
    }

internal val Res.string.feature_apply_loan_action_save_draft: StringResource by lazy {
      StringResource("string:feature_apply_loan_action_save_draft", "feature_apply_loan_action_save_draft", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 267, 60),
      ))
    }

internal val Res.string.feature_apply_loan_button_apply: StringResource by lazy {
      StringResource("string:feature_apply_loan_button_apply", "feature_apply_loan_button_apply", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328, 55),
      ))
    }

internal val Res.string.feature_apply_loan_button_cancel: StringResource by lazy {
      StringResource("string:feature_apply_loan_button_cancel", "feature_apply_loan_button_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 384, 48),
      ))
    }

internal val Res.string.feature_apply_loan_button_continue: StringResource by lazy {
      StringResource("string:feature_apply_loan_button_continue", "feature_apply_loan_button_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 433, 54),
      ))
    }

internal val Res.string.feature_apply_loan_button_ok: StringResource by lazy {
      StringResource("string:feature_apply_loan_button_ok", "feature_apply_loan_button_ok", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 488, 40),
      ))
    }

internal val Res.string.feature_apply_loan_error_amount_empty: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_amount_empty", "feature_apply_loan_error_amount_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 529, 85),
      ))
    }

internal val Res.string.feature_apply_loan_error_amount_invalid_decimal: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_amount_invalid_decimal", "feature_apply_loan_error_amount_invalid_decimal", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 615, 131),
      ))
    }

internal val Res.string.feature_apply_loan_error_amount_invalid_format: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_amount_invalid_format", "feature_apply_loan_error_amount_invalid_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 747, 102),
      ))
    }

internal val Res.string.feature_apply_loan_error_amount_too_large: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_amount_too_large", "feature_apply_loan_error_amount_too_large", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 850, 101),
      ))
    }

internal val Res.string.feature_apply_loan_error_amount_too_small: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_amount_too_small", "feature_apply_loan_error_amount_too_small", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 952, 89),
      ))
    }

internal val Res.string.feature_apply_loan_error_date_empty: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_date_empty", "feature_apply_loan_error_date_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1042, 83),
      ))
    }

internal val Res.string.feature_apply_loan_error_date_future: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_date_future", "feature_apply_loan_error_date_future", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1126, 96),
      ))
    }

internal val Res.string.feature_apply_loan_error_date_invalid_format: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_date_invalid_format", "feature_apply_loan_error_date_invalid_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1223, 112),
      ))
    }

internal val Res.string.feature_apply_loan_error_date_out_of_range: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_date_out_of_range", "feature_apply_loan_error_date_out_of_range", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1336, 126),
      ))
    }

internal val Res.string.feature_apply_loan_error_name_empty: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_name_empty", "feature_apply_loan_error_name_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1463, 79),
      ))
    }

internal val Res.string.feature_apply_loan_error_name_invalid_format: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_name_invalid_format", "feature_apply_loan_error_name_invalid_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1543, 108),
      ))
    }

internal val Res.string.feature_apply_loan_error_name_too_long: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_name_too_long", "feature_apply_loan_error_name_too_long", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1652, 106),
      ))
    }

internal val Res.string.feature_apply_loan_error_name_too_short: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_name_too_short", "feature_apply_loan_error_name_too_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1759, 107),
      ))
    }

internal val Res.string.feature_apply_loan_error_product_empty: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_product_empty", "feature_apply_loan_error_product_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1867, 78),
      ))
    }

internal val Res.string.feature_apply_loan_error_server: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_server", "feature_apply_loan_error_server", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1946, 139),
      ))
    }

internal val Res.string.feature_apply_loan_error_submit_failed: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_submit_failed", "feature_apply_loan_error_submit_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2086, 118),
      ))
    }

internal val Res.string.feature_apply_loan_error_too_many_attempts: StringResource by lazy {
      StringResource("string:feature_apply_loan_error_too_many_attempts", "feature_apply_loan_error_too_many_attempts", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2205, 118),
      ))
    }

internal val Res.string.feature_apply_loan_hint_applicant_name: StringResource by lazy {
      StringResource("string:feature_apply_loan_hint_applicant_name", "feature_apply_loan_hint_applicant_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2324, 74),
      ))
    }

internal val Res.string.feature_apply_loan_hint_disbursement_date: StringResource by lazy {
      StringResource("string:feature_apply_loan_hint_disbursement_date", "feature_apply_loan_hint_disbursement_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2399, 81),
      ))
    }

internal val Res.string.feature_apply_loan_hint_loan_product: StringResource by lazy {
      StringResource("string:feature_apply_loan_hint_loan_product", "feature_apply_loan_hint_loan_product", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2481, 72),
      ))
    }

internal val Res.string.feature_apply_loan_hint_principal_amount: StringResource by lazy {
      StringResource("string:feature_apply_loan_hint_principal_amount", "feature_apply_loan_hint_principal_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2554, 72),
      ))
    }

internal val Res.string.feature_apply_loan_hint_purpose: StringResource by lazy {
      StringResource("string:feature_apply_loan_hint_purpose", "feature_apply_loan_hint_purpose", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2627, 79),
      ))
    }

internal val Res.string.feature_apply_loan_info_confirm_details: StringResource by lazy {
      StringResource("string:feature_apply_loan_info_confirm_details", "feature_apply_loan_info_confirm_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2707, 67),
      ))
    }

internal val Res.string.feature_apply_loan_info_currency_revalidation: StringResource by lazy {
      StringResource("string:feature_apply_loan_info_currency_revalidation", "feature_apply_loan_info_currency_revalidation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2775, 113),
      ))
    }

internal val Res.string.feature_apply_loan_info_max_amount: StringResource by lazy {
      StringResource("string:feature_apply_loan_info_max_amount", "feature_apply_loan_info_max_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2889, 78),
      ))
    }

internal val Res.string.feature_apply_loan_info_min_amount: StringResource by lazy {
      StringResource("string:feature_apply_loan_info_min_amount", "feature_apply_loan_info_min_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2968, 78),
      ))
    }

internal val Res.string.feature_apply_loan_label_applicant_name: StringResource by lazy {
      StringResource("string:feature_apply_loan_label_applicant_name", "feature_apply_loan_label_applicant_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3047, 67),
      ))
    }

internal val Res.string.feature_apply_loan_label_currency: StringResource by lazy {
      StringResource("string:feature_apply_loan_label_currency", "feature_apply_loan_label_currency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3115, 53),
      ))
    }

internal val Res.string.feature_apply_loan_label_disbursement_date: StringResource by lazy {
      StringResource("string:feature_apply_loan_label_disbursement_date", "feature_apply_loan_label_disbursement_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3169, 74),
      ))
    }

internal val Res.string.feature_apply_loan_label_loan_product: StringResource by lazy {
      StringResource("string:feature_apply_loan_label_loan_product", "feature_apply_loan_label_loan_product", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3244, 61),
      ))
    }

internal val Res.string.feature_apply_loan_label_principal_amount: StringResource by lazy {
      StringResource("string:feature_apply_loan_label_principal_amount", "feature_apply_loan_label_principal_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3306, 73),
      ))
    }

internal val Res.string.feature_apply_loan_label_purpose: StringResource by lazy {
      StringResource("string:feature_apply_loan_label_purpose", "feature_apply_loan_label_purpose", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3380, 60),
      ))
    }

internal val Res.string.feature_apply_loan_section_fill_details: StringResource by lazy {
      StringResource("string:feature_apply_loan_section_fill_details", "feature_apply_loan_section_fill_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3441, 79),
      ))
    }

internal val Res.string.feature_apply_loan_status_failure: StringResource by lazy {
      StringResource("string:feature_apply_loan_status_failure", "feature_apply_loan_status_failure", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3732, 73),
      ))
    }

internal val Res.string.feature_apply_loan_status_failure_action: StringResource by lazy {
      StringResource("string:feature_apply_loan_status_failure_action", "feature_apply_loan_status_failure_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3521, 60),
      ))
    }

internal val Res.string.feature_apply_loan_status_failure_tip: StringResource by lazy {
      StringResource("string:feature_apply_loan_status_failure_tip", "feature_apply_loan_status_failure_tip", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3582, 149),
      ))
    }

internal val Res.string.feature_apply_loan_status_success: StringResource by lazy {
      StringResource("string:feature_apply_loan_status_success", "feature_apply_loan_status_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4029, 81),
      ))
    }

internal val Res.string.feature_apply_loan_status_success_action: StringResource by lazy {
      StringResource("string:feature_apply_loan_status_success_action", "feature_apply_loan_status_success_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3806, 64),
      ))
    }

internal val Res.string.feature_apply_loan_status_success_tip: StringResource by lazy {
      StringResource("string:feature_apply_loan_status_success_tip", "feature_apply_loan_status_success_tip", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3871, 157),
      ))
    }

internal val Res.string.feature_apply_loan_success_draft_saved: StringResource by lazy {
      StringResource("string:feature_apply_loan_success_draft_saved", "feature_apply_loan_success_draft_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4111, 94),
      ))
    }

internal val Res.string.feature_apply_loan_success_submit: StringResource by lazy {
      StringResource("string:feature_apply_loan_success_submit", "feature_apply_loan_success_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4206, 97),
      ))
    }

internal val Res.string.feature_apply_loan_title: StringResource by lazy {
      StringResource("string:feature_apply_loan_title", "feature_apply_loan_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4304, 52),
      ))
    }

internal val Res.string.feature_apply_loan_unsaved_changes_message: StringResource by lazy {
      StringResource("string:feature_apply_loan_unsaved_changes_message", "feature_apply_loan_unsaved_changes_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4357, 130),
      ))
    }

internal val Res.string.feature_apply_loan_unsaved_changes_title: StringResource by lazy {
      StringResource("string:feature_apply_loan_unsaved_changes_title", "feature_apply_loan_unsaved_changes_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4488, 72),
      ))
    }

internal val Res.string.feature_button_next: StringResource by lazy {
      StringResource("string:feature_button_next", "feature_button_next", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4561, 35),
      ))
    }

internal val Res.string.feature_loan_amendments_and_termination: StringResource by lazy {
      StringResource("string:feature_loan_amendments_and_termination", "feature_loan_amendments_and_termination", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4597, 83),
      ))
    }

internal val Res.string.feature_loan_apply_loan: StringResource by lazy {
      StringResource("string:feature_loan_apply_loan", "feature_loan_apply_loan", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4681, 51),
      ))
    }

internal val Res.string.feature_loan_continue: StringResource by lazy {
      StringResource("string:feature_loan_continue", "feature_loan_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4804, 41),
      ))
    }

internal val Res.string.feature_loan_continue_legal_compliance: StringResource by lazy {
      StringResource("string:feature_loan_continue_legal_compliance", "feature_loan_continue_legal_compliance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4733, 70),
      ))
    }

internal val Res.string.feature_loan_default: StringResource by lazy {
      StringResource("string:feature_loan_default", "feature_loan_default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4846, 40),
      ))
    }

internal val Res.string.feature_loan_documentation: StringResource by lazy {
      StringResource("string:feature_loan_documentation", "feature_loan_documentation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4887, 54),
      ))
    }

internal val Res.string.feature_loan_get_loan: StringResource by lazy {
      StringResource("string:feature_loan_get_loan", "feature_loan_get_loan", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4942, 49),
      ))
    }

internal val Res.string.feature_loan_insurance: StringResource by lazy {
      StringResource("string:feature_loan_insurance", "feature_loan_insurance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4992, 42),
      ))
    }

internal val Res.string.feature_loan_interest_rate: StringResource by lazy {
      StringResource("string:feature_loan_interest_rate", "feature_loan_interest_rate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5109, 54),
      ))
    }

internal val Res.string.feature_loan_interest_rate_in_numbers: StringResource by lazy {
      StringResource("string:feature_loan_interest_rate_in_numbers", "feature_loan_interest_rate_in_numbers", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5035, 73),
      ))
    }

internal val Res.string.feature_loan_jurisdiction: StringResource by lazy {
      StringResource("string:feature_loan_jurisdiction", "feature_loan_jurisdiction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5164, 49),
      ))
    }

internal val Res.string.feature_loan_product_details_terms: StringResource by lazy {
      StringResource("string:feature_loan_product_details_terms", "feature_loan_product_details_terms", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5214, 78),
      ))
    }

internal val Res.string.feature_loan_repayment: StringResource by lazy {
      StringResource("string:feature_loan_repayment", "feature_loan_repayment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5293, 42),
      ))
    }

internal val Res.string.feature_loan_sanction_and_disbursement: StringResource by lazy {
      StringResource("string:feature_loan_sanction_and_disbursement", "feature_loan_sanction_and_disbursement", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5336, 86),
      ))
    }

internal val Res.string.feature_loan_security_and_collateral: StringResource by lazy {
      StringResource("string:feature_loan_security_and_collateral", "feature_loan_security_and_collateral", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5423, 76),
      ))
    }

internal val Res.string.feature_loan_terms_and_conditions: StringResource by lazy {
      StringResource("string:feature_loan_terms_and_conditions", "feature_loan_terms_and_conditions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5500, 65),
      ))
    }

internal val Res.string.feature_loan_up_to: StringResource by lazy {
      StringResource("string:feature_loan_up_to", "feature_loan_up_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5566, 38),
      ))
    }

internal val Res.string.feature_personal_loan_amendments_and_termination_details: StringResource by
    lazy {
      StringResource("string:feature_personal_loan_amendments_and_termination_details", "feature_personal_loan_amendments_and_termination_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5605, 440),
      ))
    }

internal val Res.string.feature_personal_loan_continue_legal_compliance_details: StringResource by
    lazy {
      StringResource("string:feature_personal_loan_continue_legal_compliance_details", "feature_personal_loan_continue_legal_compliance_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6046, 503),
      ))
    }

internal val Res.string.feature_personal_loan_default_details: StringResource by lazy {
      StringResource("string:feature_personal_loan_default_details", "feature_personal_loan_default_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6550, 549),
      ))
    }

internal val Res.string.feature_personal_loan_documentation_details: StringResource by lazy {
      StringResource("string:feature_personal_loan_documentation_details", "feature_personal_loan_documentation_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7100, 619),
      ))
    }

internal val Res.string.feature_personal_loan_insurance_details: StringResource by lazy {
      StringResource("string:feature_personal_loan_insurance_details", "feature_personal_loan_insurance_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7720, 495),
      ))
    }

internal val Res.string.feature_personal_loan_interest_rate_description: StringResource by lazy {
      StringResource("string:feature_personal_loan_interest_rate_description", "feature_personal_loan_interest_rate_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8216, 643),
      ))
    }

internal val Res.string.feature_personal_loan_jurisdiction_details: StringResource by lazy {
      StringResource("string:feature_personal_loan_jurisdiction_details", "feature_personal_loan_jurisdiction_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8860, 358),
      ))
    }

internal val Res.string.feature_personal_loan_repayment_details: StringResource by lazy {
      StringResource("string:feature_personal_loan_repayment_details", "feature_personal_loan_repayment_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9219, 679),
      ))
    }

internal val Res.string.feature_personal_loan_sanction_and_disbursement_details: StringResource by
    lazy {
      StringResource("string:feature_personal_loan_sanction_and_disbursement_details", "feature_personal_loan_sanction_and_disbursement_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9899, 851),
      ))
    }

internal val Res.string.feature_personal_loan_security_and_collateral_details: StringResource by
    lazy {
      StringResource("string:feature_personal_loan_security_and_collateral_details", "feature_personal_loan_security_and_collateral_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10751, 617),
      ))
    }

internal val Res.string.feature_select_loan_type_choose_loan: StringResource by lazy {
      StringResource("string:feature_select_loan_type_choose_loan", "feature_select_loan_type_choose_loan", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11369, 72),
      ))
    }

internal val Res.string.feature_select_loan_type_empty: StringResource by lazy {
      StringResource("string:feature_select_loan_type_empty", "feature_select_loan_type_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11442, 94),
      ))
    }

internal val Res.string.feature_select_loan_type_network_issue: StringResource by lazy {
      StringResource("string:feature_select_loan_type_network_issue", "feature_select_loan_type_network_issue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11537, 90),
      ))
    }

internal val Res.string.feature_select_loan_type_top_bar_title: StringResource by lazy {
      StringResource("string:feature_select_loan_type_top_bar_title", "feature_select_loan_type_top_bar_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11628, 66),
      ))
    }

internal val Res.string.feature_upload_docs_bank_account: StringResource by lazy {
      StringResource("string:feature_upload_docs_bank_account", "feature_upload_docs_bank_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11695, 80),
      ))
    }

internal val Res.string.feature_upload_docs_collateral: StringResource by lazy {
      StringResource("string:feature_upload_docs_collateral", "feature_upload_docs_collateral", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11776, 74),
      ))
    }

internal val Res.string.feature_upload_docs_signature: StringResource by lazy {
      StringResource("string:feature_upload_docs_signature", "feature_upload_docs_signature", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11851, 61),
      ))
    }

internal val Res.string.feature_upload_documents_success_title: StringResource by lazy {
      StringResource("string:feature_upload_documents_success_title", "feature_upload_documents_success_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11913, 90),
      ))
    }

internal val Res.string.feature_upload_file_error: StringResource by lazy {
      StringResource("string:feature_upload_file_error", "feature_upload_file_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12004, 93),
      ))
    }

internal val Res.string.feature_upload_property_document_error: StringResource by lazy {
      StringResource("string:feature_upload_property_document_error", "feature_upload_property_document_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12098, 90),
      ))
    }

internal val Res.string.feature_upload_signature_error: StringResource by lazy {
      StringResource("string:feature_upload_signature_error", "feature_upload_signature_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12189, 74),
      ))
    }

internal val Res.string.feature_upload_statement_error: StringResource by lazy {
      StringResource("string:feature_upload_statement_error", "feature_upload_statement_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12264, 78),
      ))
    }

internal val Res.string.reset: StringResource by lazy {
      StringResource("string:reset", "reset", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12343, 21),
      ))
    }

internal val Res.string.save_and_submit: StringResource by lazy {
      StringResource("string:save_and_submit", "save_and_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12365, 43),
      ))
    }

internal val Res.string.sign: StringResource by lazy {
      StringResource("string:sign", "sign", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12439, 20),
      ))
    }

internal val Res.string.sign_here: StringResource by lazy {
      StringResource("string:sign_here", "sign_here", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12409, 29),
      ))
    }

internal val Res.string.upload_signature: StringResource by lazy {
      StringResource("string:upload_signature", "upload_signature", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12460, 48),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("attach", Res.string.attach)
  map.put("capture", Res.string.capture)
  map.put("feature_apply_loan_action_cancel", Res.string.feature_apply_loan_action_cancel)
  map.put("feature_apply_loan_action_continue", Res.string.feature_apply_loan_action_continue)
  map.put("feature_apply_loan_action_discard", Res.string.feature_apply_loan_action_discard)
  map.put("feature_apply_loan_action_retry", Res.string.feature_apply_loan_action_retry)
  map.put("feature_apply_loan_action_save_draft", Res.string.feature_apply_loan_action_save_draft)
  map.put("feature_apply_loan_button_apply", Res.string.feature_apply_loan_button_apply)
  map.put("feature_apply_loan_button_cancel", Res.string.feature_apply_loan_button_cancel)
  map.put("feature_apply_loan_button_continue", Res.string.feature_apply_loan_button_continue)
  map.put("feature_apply_loan_button_ok", Res.string.feature_apply_loan_button_ok)
  map.put("feature_apply_loan_error_amount_empty", Res.string.feature_apply_loan_error_amount_empty)
  map.put("feature_apply_loan_error_amount_invalid_decimal", Res.string.feature_apply_loan_error_amount_invalid_decimal)
  map.put("feature_apply_loan_error_amount_invalid_format", Res.string.feature_apply_loan_error_amount_invalid_format)
  map.put("feature_apply_loan_error_amount_too_large", Res.string.feature_apply_loan_error_amount_too_large)
  map.put("feature_apply_loan_error_amount_too_small", Res.string.feature_apply_loan_error_amount_too_small)
  map.put("feature_apply_loan_error_date_empty", Res.string.feature_apply_loan_error_date_empty)
  map.put("feature_apply_loan_error_date_future", Res.string.feature_apply_loan_error_date_future)
  map.put("feature_apply_loan_error_date_invalid_format", Res.string.feature_apply_loan_error_date_invalid_format)
  map.put("feature_apply_loan_error_date_out_of_range", Res.string.feature_apply_loan_error_date_out_of_range)
  map.put("feature_apply_loan_error_name_empty", Res.string.feature_apply_loan_error_name_empty)
  map.put("feature_apply_loan_error_name_invalid_format", Res.string.feature_apply_loan_error_name_invalid_format)
  map.put("feature_apply_loan_error_name_too_long", Res.string.feature_apply_loan_error_name_too_long)
  map.put("feature_apply_loan_error_name_too_short", Res.string.feature_apply_loan_error_name_too_short)
  map.put("feature_apply_loan_error_product_empty", Res.string.feature_apply_loan_error_product_empty)
  map.put("feature_apply_loan_error_server", Res.string.feature_apply_loan_error_server)
  map.put("feature_apply_loan_error_submit_failed", Res.string.feature_apply_loan_error_submit_failed)
  map.put("feature_apply_loan_error_too_many_attempts", Res.string.feature_apply_loan_error_too_many_attempts)
  map.put("feature_apply_loan_hint_applicant_name", Res.string.feature_apply_loan_hint_applicant_name)
  map.put("feature_apply_loan_hint_disbursement_date", Res.string.feature_apply_loan_hint_disbursement_date)
  map.put("feature_apply_loan_hint_loan_product", Res.string.feature_apply_loan_hint_loan_product)
  map.put("feature_apply_loan_hint_principal_amount", Res.string.feature_apply_loan_hint_principal_amount)
  map.put("feature_apply_loan_hint_purpose", Res.string.feature_apply_loan_hint_purpose)
  map.put("feature_apply_loan_info_confirm_details", Res.string.feature_apply_loan_info_confirm_details)
  map.put("feature_apply_loan_info_currency_revalidation", Res.string.feature_apply_loan_info_currency_revalidation)
  map.put("feature_apply_loan_info_max_amount", Res.string.feature_apply_loan_info_max_amount)
  map.put("feature_apply_loan_info_min_amount", Res.string.feature_apply_loan_info_min_amount)
  map.put("feature_apply_loan_label_applicant_name", Res.string.feature_apply_loan_label_applicant_name)
  map.put("feature_apply_loan_label_currency", Res.string.feature_apply_loan_label_currency)
  map.put("feature_apply_loan_label_disbursement_date", Res.string.feature_apply_loan_label_disbursement_date)
  map.put("feature_apply_loan_label_loan_product", Res.string.feature_apply_loan_label_loan_product)
  map.put("feature_apply_loan_label_principal_amount", Res.string.feature_apply_loan_label_principal_amount)
  map.put("feature_apply_loan_label_purpose", Res.string.feature_apply_loan_label_purpose)
  map.put("feature_apply_loan_section_fill_details", Res.string.feature_apply_loan_section_fill_details)
  map.put("feature_apply_loan_status_failure", Res.string.feature_apply_loan_status_failure)
  map.put("feature_apply_loan_status_failure_action", Res.string.feature_apply_loan_status_failure_action)
  map.put("feature_apply_loan_status_failure_tip", Res.string.feature_apply_loan_status_failure_tip)
  map.put("feature_apply_loan_status_success", Res.string.feature_apply_loan_status_success)
  map.put("feature_apply_loan_status_success_action", Res.string.feature_apply_loan_status_success_action)
  map.put("feature_apply_loan_status_success_tip", Res.string.feature_apply_loan_status_success_tip)
  map.put("feature_apply_loan_success_draft_saved", Res.string.feature_apply_loan_success_draft_saved)
  map.put("feature_apply_loan_success_submit", Res.string.feature_apply_loan_success_submit)
  map.put("feature_apply_loan_title", Res.string.feature_apply_loan_title)
  map.put("feature_apply_loan_unsaved_changes_message", Res.string.feature_apply_loan_unsaved_changes_message)
  map.put("feature_apply_loan_unsaved_changes_title", Res.string.feature_apply_loan_unsaved_changes_title)
  map.put("feature_button_next", Res.string.feature_button_next)
  map.put("feature_loan_amendments_and_termination", Res.string.feature_loan_amendments_and_termination)
  map.put("feature_loan_apply_loan", Res.string.feature_loan_apply_loan)
  map.put("feature_loan_continue", Res.string.feature_loan_continue)
  map.put("feature_loan_continue_legal_compliance", Res.string.feature_loan_continue_legal_compliance)
  map.put("feature_loan_default", Res.string.feature_loan_default)
  map.put("feature_loan_documentation", Res.string.feature_loan_documentation)
  map.put("feature_loan_get_loan", Res.string.feature_loan_get_loan)
  map.put("feature_loan_insurance", Res.string.feature_loan_insurance)
  map.put("feature_loan_interest_rate", Res.string.feature_loan_interest_rate)
  map.put("feature_loan_interest_rate_in_numbers", Res.string.feature_loan_interest_rate_in_numbers)
  map.put("feature_loan_jurisdiction", Res.string.feature_loan_jurisdiction)
  map.put("feature_loan_product_details_terms", Res.string.feature_loan_product_details_terms)
  map.put("feature_loan_repayment", Res.string.feature_loan_repayment)
  map.put("feature_loan_sanction_and_disbursement", Res.string.feature_loan_sanction_and_disbursement)
  map.put("feature_loan_security_and_collateral", Res.string.feature_loan_security_and_collateral)
  map.put("feature_loan_terms_and_conditions", Res.string.feature_loan_terms_and_conditions)
  map.put("feature_loan_up_to", Res.string.feature_loan_up_to)
  map.put("feature_personal_loan_amendments_and_termination_details", Res.string.feature_personal_loan_amendments_and_termination_details)
  map.put("feature_personal_loan_continue_legal_compliance_details", Res.string.feature_personal_loan_continue_legal_compliance_details)
  map.put("feature_personal_loan_default_details", Res.string.feature_personal_loan_default_details)
  map.put("feature_personal_loan_documentation_details", Res.string.feature_personal_loan_documentation_details)
  map.put("feature_personal_loan_insurance_details", Res.string.feature_personal_loan_insurance_details)
  map.put("feature_personal_loan_interest_rate_description", Res.string.feature_personal_loan_interest_rate_description)
  map.put("feature_personal_loan_jurisdiction_details", Res.string.feature_personal_loan_jurisdiction_details)
  map.put("feature_personal_loan_repayment_details", Res.string.feature_personal_loan_repayment_details)
  map.put("feature_personal_loan_sanction_and_disbursement_details", Res.string.feature_personal_loan_sanction_and_disbursement_details)
  map.put("feature_personal_loan_security_and_collateral_details", Res.string.feature_personal_loan_security_and_collateral_details)
  map.put("feature_select_loan_type_choose_loan", Res.string.feature_select_loan_type_choose_loan)
  map.put("feature_select_loan_type_empty", Res.string.feature_select_loan_type_empty)
  map.put("feature_select_loan_type_network_issue", Res.string.feature_select_loan_type_network_issue)
  map.put("feature_select_loan_type_top_bar_title", Res.string.feature_select_loan_type_top_bar_title)
  map.put("feature_upload_docs_bank_account", Res.string.feature_upload_docs_bank_account)
  map.put("feature_upload_docs_collateral", Res.string.feature_upload_docs_collateral)
  map.put("feature_upload_docs_signature", Res.string.feature_upload_docs_signature)
  map.put("feature_upload_documents_success_title", Res.string.feature_upload_documents_success_title)
  map.put("feature_upload_file_error", Res.string.feature_upload_file_error)
  map.put("feature_upload_property_document_error", Res.string.feature_upload_property_document_error)
  map.put("feature_upload_signature_error", Res.string.feature_upload_signature_error)
  map.put("feature_upload_statement_error", Res.string.feature_upload_statement_error)
  map.put("reset", Res.string.reset)
  map.put("save_and_submit", Res.string.save_and_submit)
  map.put("sign", Res.string.sign)
  map.put("sign_here", Res.string.sign_here)
  map.put("upload_signature", Res.string.upload_signature)
}
